import { z } from 'zod';

export const itemTreeSetEntrySchema = z.object({
  itemId: z.number().int().positive(),
  parentId: z.number().int().positive().optional(),
  matched: z.boolean(),
  itemTypeId: z.number().int().positive(),
  hasExternalKey: z.boolean(),
  loopId: z.number().int().positive(),
});

export type ItemTreeSetEntryDTO = z.infer<typeof itemTreeSetEntrySchema>;
